import React from 'react'

import waharoa from '../../images/WAHAROA TITLE.jpg'
import waharoa2 from '../../images/WAHAROA.JPG'
import waharoa3 from '../../images/WAHAROA 3.JPG'

function Waharoa() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={waharoa}
            className="project-image" />
          <img
            src={waharoa2}
            className="project-image" />
          <img
            src={waharoa3}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Waharoa</h1>
          <p className="Project-text">
            <strong>
              Ella Gilbert - Creator, Choreographer, Performer, Granddaughter
              <br />
              Jennifer Shearer - Performer, Co Choreographer, Grandmother
              <br />
              Grace Bentley Tsibuah - Sound Designer
              <br />
              Chris Jannides - Advisor
              <br />
              Teina Moetara - Advisor
              <br />
              Ngapaki Moetara - Advisor
            </strong>
          </p>
          <p className="Project-testimonial">
            That was just. Exquisite! The time and space you opened up was incredible...so sensitive and thoughtful and dreamy
          </p>
          <h6 className="Testimonial-person">
            <strong>~Director of Tempo Dance Festival, Cat Ruka</strong>
          </h6>
          <p className="Project-testimonial">
            I watched from the comfort of my bed and thought of my own grandmother, and of this gift that Ella and Jennifer were sharing with us. The open vulnerability they kept sharing. The willingness to try something new, together. That this was an oral, embodied storytelling in the digital age.
          </p>
          <h6 className="Testimonial-person">
            <strong>~Pantograph Punch, Pelenakeke Brown</strong>
          </h6>
          <p className="Project-text">
            My grandma and I are video calling to create a duet. We are reaching across internet space - to connect - to make contact. 
            We are doing this via the computer, because that is the current restriction. And there is potential in restriction.
          </p>
          <p className="Project-text">
            A live video call performance between Ella and Grandma Jenny.
          </p>
          <p className="Project-text">
            Waharoa was a commissioned 1hour performance for Tempo Dance Festival. Made with love during the national level 4 lockdown, 2020.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Waharoa
